import { axios } from '@/utils/request'

const api = {
  goodsOptions: '/badminapi/tuan/goodsOptions',
  goodsSkuDetail: '/badminapi/tuan/goodsSkuDetail',
  tuanDetail: '/badminapi/tuan/tuanDetail',
  tuanList: '/badminapi/tuan/tuanList',
  tuanEdit: '/badminapi/tuan/tuanEdit',
  tuanAdd: '/badminapi/tuan/tuanAdd',
  tuanRankEdit: '/badminapi/tuan/tuanRankEdit',
  tuanDelete: '/badminapi/tuan/tuanDelete',
  setTuanAllStatus: '/badminapi/tuan/setTuanAllStatus',
  tuanOrderList: '/badminapi/tuan/orderList',
}

export default api

export function getTuanList(parameter) {
  return axios({
    url: api.tuanList,
    method: 'get',
    params: parameter
  })
}
export function getTuanDetail(parameter) {
  return axios({
    url: api.tuanDetail,
    method: 'get',
    params: parameter
  })
}
export function getGoodsOptions(parameter) {
  return axios({
    url: api.goodsOptions,
    method: 'get',
    params: parameter
  })
}
export function getGoodsSkuDetail(parameter) {
  return axios({
    url: api.goodsSkuDetail,
    method: 'get',
    params: parameter
  })
}
export function editTuan(parameter) {
  return axios({
    url: api.tuanEdit,
    method: 'post',
    data: parameter
  })
}
export function addTuan(parameter) {
  return axios({
    url: api.tuanAdd,
    method: 'post',
    data: parameter
  })
}

export function deleteTuan(parameter) {
  return axios({
    url: api.tuanDelete,
    method: 'post',
    data: parameter
  })
}

export function setTuanRank(parameter) {
  return axios({
    url: api.tuanRankEdit,
    method: 'post',
    data: parameter
  })
}


export function setTuanAllStatus(parameter) {
  return axios({
    url: api.setTuanAllStatus,
    method: 'post',
    data: parameter
  })
}
export function getTuanUserList(parameter) {
  return axios({
    url: api.tuanOrderList,
    method: 'post',
    data: parameter
  })
}